import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessAddProduct} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessAddProductPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessAddProductPage;
  }

  render() {
    return (
      <MasterLayout isActive='my-business-post-product'>
        <MyBusinessAddProduct params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessAddProductPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessAddProductPage.jsx